var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("p", { staticClass: "text-center" }, [
      _c("span", { staticClass: "btn-group" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-light",
            attrs: {
              disabled: _setup.selectedIds.length === 0,
              type: "button",
            },
            on: { click: _setup.sendArrivalFormEmails },
          },
          [_vm._v("\n                Arrival form email\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-light",
            attrs: {
              disabled: _setup.selectedIds.length === 0,
              type: "button",
            },
            on: { click: _setup.sendEquipmentSalesEmails },
          },
          [_vm._v("\n                Equipment sales email\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-light",
            attrs: {
              disabled: _setup.selectedIds.length === 0,
              type: "button",
            },
            on: { click: _setup.sendRequestReviewEmails },
          },
          [_vm._v("\n                Request review email\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "btn-group" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-light",
            attrs: {
              disabled: _setup.selectedIds.length === 0,
              type: "button",
            },
            on: {
              click: function ($event) {
                return _setup.printDocument(104, "Arrival sheet", {})
              },
            },
          },
          [_vm._v("\n                Arrivals sheet\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-light",
            attrs: {
              disabled: _setup.selectedIds.length === 0,
              type: "button",
            },
            on: {
              click: function ($event) {
                return _setup.printAirportTransferSheet(0)
              },
            },
          },
          [_vm._v("\n                Pickups\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-light",
            attrs: {
              disabled: _setup.selectedIds.length === 0,
              type: "button",
            },
            on: {
              click: function ($event) {
                return _setup.printAirportTransferSheet(1)
              },
            },
          },
          [_vm._v("\n                Departures\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-light",
          attrs: { disabled: _setup.selectedIds.length === 0, type: "button" },
          on: { click: _setup.archiveBookings },
        },
        [_vm._v("\n            Archive bookings\n        ")]
      ),
      _vm._v(" "),
      _setup.courseDate
        ? _c(
            "button",
            {
              staticClass: "btn btn-light",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _setup.printDocument(193, "Weekly log sheet", {
                    templateVars: {
                      pageTitle: _setup.courseDate.name,
                      customerNames: _setup.bookings
                        ? _setup.bookings.map(
                            (o) => o.firstName + " " + o.lastName
                          )
                        : [],
                    },
                  })
                },
              },
            },
            [_vm._v("\n            Weekly log sheet\n        ")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c("td", [
              _c("input", {
                attrs: { type: "checkbox" },
                domProps: { checked: _setup.allSelected },
                on: { click: _setup.toggleAllCheckboxes },
              }),
            ]),
            _vm._v(" "),
            _vm._l(_setup.columns, function (title, name) {
              return _c(
                "td",
                {
                  key: name,
                  on: {
                    click: function ($event) {
                      return _setup.sortColumns(name)
                    },
                  },
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _setup.orderBy === name,
                        expression: "orderBy === name",
                      },
                    ],
                    class: {
                      "bi-chevron-down": _setup.orderDesc,
                      "bi-chevron-up": !_setup.orderDesc,
                    },
                    attrs: { role: "button" },
                  }),
                  _vm._v(
                    "\n                " + _vm._s(title) + "\n            "
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_setup.orderedRows, function (row) {
          return _c("tr", { key: row.id }, [
            _c("td", [
              _c("input", {
                attrs: { type: "checkbox" },
                domProps: { checked: _setup.selectedIds.includes(row.id) },
                on: {
                  click: function ($event) {
                    return _setup.selectCheckbox(row.id)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _setup.goToBooking(row.id)
                    },
                  },
                },
                [_vm._v(_vm._s(row.id))]
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(row.firstName))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(row.lastName))]),
            _vm._v(" "),
            _c("td", [
              _setup.customerIdsWithConsecutiveBookings?.includes(
                row.customerId
              )
                ? _c("i", { staticClass: "bi bi-check2" })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(row.accommodation))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(row.tandemFlight ? "€200 extra" : ""))]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(row.trikeFlyingWithWheels ? "€300 extra" : "")),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: row.price,
                    expression: "row.price",
                  },
                ],
                staticClass: "form-control input-sm",
                attrs: { size: "5" },
                domProps: { value: row.price },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(row, "price", $event.target.value)
                    },
                    function ($event) {
                      return _setup.saveAmount($event, row.id, "price")
                    },
                  ],
                },
              }),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: row.depositAmountPaid,
                    expression: "row.depositAmountPaid",
                  },
                ],
                staticClass: "form-control input-sm",
                attrs: { size: "5" },
                domProps: { value: row.depositAmountPaid },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(row, "depositAmountPaid", $event.target.value)
                    },
                    function ($event) {
                      return _setup.saveAmount(
                        $event,
                        row.id,
                        "depositAmountPaid"
                      )
                    },
                  ],
                },
              }),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: row.finalPaymentAmountPaid,
                    expression: "row.finalPaymentAmountPaid",
                  },
                ],
                staticClass: "form-control input-sm",
                attrs: { size: "5" },
                domProps: { value: row.finalPaymentAmountPaid },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        row,
                        "finalPaymentAmountPaid",
                        $event.target.value
                      )
                    },
                    function ($event) {
                      return _setup.saveAmount(
                        $event,
                        row.id,
                        "finalPaymentAmountPaid"
                      )
                    },
                  ],
                },
              }),
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(
                  row.equipmentSalesEmailLastSent
                    ? _setup.getDate(row.equipmentSalesEmailLastSent)
                    : null
                )
              ),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c(
                  _setup.Button,
                  {
                    staticClass: "btn-sm",
                    attrs: { "active-value": !!row.notes },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.showNotes(row)
                      },
                    },
                  },
                  [_vm._v("Edit")]
                ),
              ],
              1
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }